import View from "../common/views/PopoverTopVendorView";
import components from "./components.js";
components.define("js-popoverTopVendor", View);